import { Controller } from "@hotwired/stimulus"

// Odliczanie cooldownu na linku „Wyślij kod ponownie" (ekran weryfikacji 2FA).
//
// Serwer renderuje pozostały cooldown (rate limit resend) w cooldown-seconds-value —
// zarówno zaraz po wysłaniu kodu, jak i przy wejściu na stronę w trakcie blokady.
// Kontroler wyszarza link, tyka co sekundę sufiksem "(M:SS)" i przywraca link po
// zejściu do zera. Klik w trakcie cooldownu jest blokowany (preventDefault +
// stopPropagation — UJS data-method nasłuchuje na document i nie sprawdza
// defaultPrevented, więc samo preventDefault nie wystarczy).
//
// Values/classes z ERB (verification.html+tailwind.erb):
//   - cooldown-seconds-value — pozostałe sekundy (0 = link aktywny)
//   - label-text-value       — bazowy tekst linku (do sufiksu i przywrócenia)
//   - disabled-class         — klasy wyszarzenia
//   - enabled-class          — klasy aktywnego linku
export default class extends Controller {
  static values = {
    cooldownSeconds: { type: Number, default: 0 },
    labelText: String,
    unitText: String,
    autoStart: { type: Boolean, default: true },
  }

  static classes = ["disabled", "enabled"]

  connect() {
    this.blockClick = (event) => {
      event.preventDefault()
      event.stopPropagation()
    }
    if (this.autoStartValue && this.cooldownSecondsValue > 0) this.startCooldown(this.cooldownSecondsValue)
  }

  // Uruchamiane zewnętrznie eventem (np. po AJAX-owym sendCode w modalu 2FA),
  // niezależnie od connect()/autoStartValue. Reużywa tej samej cooldownSecondsValue
  // co auto-start — długość cooldownu i tak jest stała, skonfigurowana raz w ERB.
  start() {
    this.startCooldown(this.cooldownSecondsValue)
  }

  disconnect() {
    this.stopTimer()
    this.element.removeEventListener("click", this.blockClick)
  }

  startCooldown(seconds) {
    this.remaining = Math.ceil(seconds)
    this.disable()
    this.updateLabel()
    this.stopTimer()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  tick() {
    this.remaining -= 1
    if (this.remaining <= 0) {
      this.stopTimer()
      this.enable()
    } else {
      this.updateLabel()
    }
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  // Linki (<a>) nie mają natywnego stanu disabled — stąd classList + aria-disabled
  // + blokowanie kliku. Prawdziwe <button> (np. w modalu 2FA) juz to maja
  disable() {
    if ("disabled" in this.element) {
      this.element.disabled = true
    } else {
      this.element.addEventListener("click", this.blockClick)
      this.element.setAttribute("aria-disabled", "true")
      this.element.classList.remove(...this.enabledClasses)
      this.element.classList.add(...this.disabledClasses)
    }
  }

  enable() {
    if ("disabled" in this.element) {
      this.element.disabled = false
    } else {
      this.element.removeEventListener("click", this.blockClick)
      this.element.removeAttribute("aria-disabled")
      this.element.classList.remove(...this.disabledClasses)
      this.element.classList.add(...this.enabledClasses)
    }
    this.element.textContent = this.labelTextValue
  }

  updateLabel() {
    const minutes = Math.floor(this.remaining / 60)
    const seconds = String(this.remaining % 60).padStart(2, "0")
    const unit = this.unitTextValue ? ` ${this.unitTextValue}` : ""
    this.element.textContent = `${this.labelTextValue} (${minutes}:${seconds}${unit})`
  }
}
